var map = {
	"./16-8-method.jpg": 6602,
	"./5-2-method.png": 8938,
	"./avocado-toast.jpg": 2407,
	"./baked-chicken-rice.jpg": 2295,
	"./baked-cod-sweet-potato.jpg": 29,
	"./beef-stir-fry.jpg": 8547,
	"./berry-smoothie-bowl.jpg": 2712,
	"./chia-pudding-parfait.jpg": 1433,
	"./chia-seed-pudding.jpg": 4233,
	"./chicken-caesar-salad.jpg": 2187,
	"./chickpea-salad-sandwich.jpg": 8562,
	"./coconut-flour-muffins.jpg": 6637,
	"./coconut-flour-pancakes.jpg": 4211,
	"./eat-stop-eat.jpg": 3398,
	"./grass-fed-beef-vegetables.jpg": 2198,
	"./greek-salad.jpg": 2478,
	"./greek-yogurt-bowl.jpg": 6086,
	"./greek-yogurt-parfait.jpg": 5965,
	"./green-fish-quinoa.jpg": 2260,
	"./grilled-chicken-salad.jpg": 4239,
	"./grilled-salmon-quinoa.jpg": 18,
	"./herb-crusted-chicken.jpg": 7998,
	"./hummus-vegetable-wrap.jpg": 8104,
	"./lean-beef-sweet-potato.jpg": 6512,
	"./lentil-black-bean-chili.jpg": 247,
	"./lentil-soup.jpg": 9362,
	"./lentil-vegetable-salad.jpg": 9014,
	"./oatmeal-almond-butter.jpg": 4240,
	"./oatmeal-banana.jpg": 8217,
	"./omad-method.jpg": 3869,
	"./pasta-cashew-cream.jpg": 7854,
	"./quinoa-buddha-bowl.jpg": 3971,
	"./quinoa-vegetable-salad.jpg": 5985,
	"./salmon-asparagus.jpg": 808,
	"./scrambled-eggs-avocado.jpg": 7634,
	"./seafood-paella.jpg": 3553,
	"./shrimp-avocado-salad.jpg": 921,
	"./smoked-salmon-avocado.jpg": 2978,
	"./stuffed-bell-peppers.jpg": 561,
	"./stuffed-portobello-mushrooms.jpg": 2194,
	"./sweet-potato-hash.jpg": 1415,
	"./thai-curry-tofu.jpg": 1683,
	"./tofu-scramble.jpg": 7374,
	"./tuna-salad-lettuce-wraps.jpg": 2087,
	"./turkey-vegetable-salad.jpg": 304,
	"./turkey-vegetable-soup.jpg": 7590,
	"./whole-grain-toast.jpg": 8579,
	"./zucchini-noodles-meat-sauce.jpg": 7712,
	"./zucchini-noodles-pesto.jpg": 5068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1462;